import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'PhoneNumber/zoom/importable';

export function useZoomImportablePhoneNumbersQuery({ enabled = true }: { enabled?: boolean } = {}) {
	const userSession = useUserSession();
	return useQuery({
		enabled,
		queryFn: () => userSession.webServiceHelper.callAsync<Api.IPhoneNumberMetadata[]>(BASE_QUERY_KEY, 'GET'),
		queryKey: [BASE_QUERY_KEY, userSession.user?.id],
		meta: { toastErrorMessage: 'Could not load your Zoom Phone numbers.' },
	});
}

export function invalidateZoomImportablePhoneNumbersQuery() {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY] });
}
